var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-footer"},[_c('div',{staticClass:"license"},[_vm._v("Copyright © Big Field Global PTE. Ltd. All rights reserved.")])])
}]

export { render, staticRenderFns }